var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPencil = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  stroke: "#262626",
  d: "M13.5 13.76v.333h-11v-.333zM9.977 1.828a.167.167 0 0 1 .236 0l1.886 1.886a.167.167 0 0 1 0 .236L4.62 11.427H2.5V9.305zM2.833 9.444v1.65h1.65l6.908-6.908.354-.354-.354-.353-.943-.944-.353-.353z"
})));
export default SvgPencil;